module.exports = __webpack_public_path__ + "static/media/Slide13.12a6e0b1.jpg";